import { useCallback, useEffect, useRef, useState } from 'react'

export const useRefWithCallback = <T>() => {
  const [refValue, setRefValue] = useState<T | null>(null)
  const ref = useRef<T | null>(null)

  const setRef = useCallback((node: T | null) => {
    if (node) {
      ref.current = node
      setRefValue(node)
    }
  }, [])

  return [ref, setRef, refValue] as const
}

export const useDocumentScrollManipulationForModal = (open: boolean) => {
  useEffect(() => {
    if (open) {
      // Store original styles and scroll position
      const scrollY = window.scrollY
      const html = document.documentElement
      const body = document.body

      // Store original styles for both elements
      const originalHtmlOverflow = html.style.overflow
      const originalHtmlPosition = html.style.position
      const originalHtmlTop = html.style.top
      const originalBodyOverflow = body.style.overflow
      const originalBodyPosition = body.style.position
      const originalBodyTop = body.style.top

      // Apply lock styles to both elements
      html.style.overflow = 'hidden'
      html.style.position = 'fixed'
      html.style.top = `-${scrollY}px`
      html.style.width = '100%'

      body.style.overflow = 'hidden'
      body.style.position = 'fixed'
      body.style.top = `-${scrollY}px`
      body.style.width = '100%'

      return () => {
        // Restore original styles for both elements
        html.style.overflow = originalHtmlOverflow
        html.style.position = originalHtmlPosition
        html.style.top = originalHtmlTop

        body.style.overflow = originalBodyOverflow
        body.style.position = originalBodyPosition
        body.style.top = originalBodyTop

        // Restore scroll position
        window.scrollTo(0, scrollY)
      }
    }
  }, [open])
}
